import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';


@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent {

  public constructor(private titleService: Title, private meta: Meta) {
    this.titleService.setTitle('M|Catering - About Michigan Catering');
    this.meta.updateTag({
      name: 'description',
      content: 'The Michigan Catering team is passionate about making every event special. Our vision supports the University of Michigan’s goals. All proceeds help fund Student Life.'
    });
    this.meta.updateTag({
      name: 'og:title',
      content: 'About Michigan Catering'
    });
    this.meta.updateTag({
      name: 'og:description',
      content: 'The Michigan Catering team is passionate about making every event special. Our vision supports the University of Michigan’s goals. All proceeds help fund Student Life.'
    });
  }
}
